module.exports = __webpack_public_path__ + "static/img/female.c38ed7fa.jpg";